import type {State} from 'src/reducers';
import type {State as FormData} from 'src/reducers/referral-external';
import type {
  Brand,
  JobResponse,
  JobDescription,
} from 'src/types/referral-external';


export const selectFormData = (state: State): FormData =>
  state.referralExternal;

export const selectBrand = (state: State): Brand =>
  state.referralExternal?.brand;

export const selectJobs = (state: State): JobResponse[] =>
  // @ts-expect-error - TS2339 - Property 'jobs' does not exist on type 'ReferralExternalState'.
  state.referralExternal?.jobs;

export const selectLocations = (state: State): string[] =>
  // @ts-expect-error - TS2339 - Property 'locations' does not exist on type 'ReferralExternalState'.
  state.referralExternal?.locations;

export const selectJobDescription = (state: State): JobDescription =>
  // @ts-expect-error - TS2339 - Property 'jobDescription' does not exist on type 'ReferralExternalState'.
  state.referralExternal?.jobDescription;

export const selectFormApiError = (state: State): JobDescription =>
  // @ts-expect-error - TS2339 - Property 'questionnaire_api_error' does not exist on type 'ReferralExternalState'.
  state.referralExternal?.questionnaire_api_error;
